import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import {FormControl} from '@angular/forms';
import { CommonService } from '../services/common/common.service';
import * as Highcharts from 'highcharts';
import { config } from '../config';
import { HttpService } from '../services/http/http.service';
import { UiService } from '../services/uiloader/uiloader.service';
import { ToasterService } from '../services/toaster/toaster.service';
import { AuthService } from '../auth/auth.service';
import { AppConstants } from '../constants/appConstants';
import { Subject, fromEvent } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PlatformLocation } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientDataService } from '../services/client-data/client-data.service';

@Component({
  selector: 'app-clientdashboard',
  templateUrl: './clientdashboard.component.html',
  styleUrls: ['./clientdashboard.component.sass']
})
export class ClientdashboardComponent implements OnInit,OnDestroy {
  isDisplayClientDashboard: boolean = false;
  maxDate:any = new Date();
  @Input() selectedUserRole:any = '';
  @Input() userId:any =  '';

  errorMsg:string = '';
  companyUrl:any;
  constructor(public commonService: CommonService, private httpService: HttpService,
    private loader: UiService,
    private toasterService: ToasterService,
    private authService: AuthService, private platformLocation:PlatformLocation, private route:ActivatedRoute, private router: Router, private clientDataService: ClientDataService) { 
      history.pushState(null, '', location.href);
      this.platformLocation.onPopState(()=>{
        history.pushState(null, '', location.href)
      })

    }
    isTodayDate = true;
  dashboardData:any = {
    exercise: {},
    goal: {},
    nutrition: {
      calories: {}
    },
    weights: [{}]
  };

  isDashboardLoaded:boolean = false;

  exerciseData: any = [{
    title: 'Exercises',
    actual: '2',
    total: '3',
    percent: 40
  },
{
  title: 'Total Sets',
  actual: 5,
  total: 6,
  percent: 60
},
{
  title: 'Total Reps',
  actual: 10,
  total: 20,
  percent: 50
},
{
  title: 'Cardio',
  actual: 8,
  total: 10,
  percent: 70
}];

goalsDate = new FormControl(new Date());

updateNutritionFlag = false;
isConsultantView =false;
companyDetails: any = null;
currentClientCount: number = 0;
nutritionChartOptions: Highcharts.Options = {
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
      style: {
        fontFamily: 'Lato, sans-serif'
      }
    },
    title: {
      text: '',
      align: 'left'
    },
    credits: {
      enabled: false
    },
    xAxis: {
      categories: [
        'Protein <br/> <span>0</span',
        'Fat<br/> <span>0</span',
        'Carbs<br/> <span>0</span'
      ],
      gridLineWidth: 0,
      lineWidth: 0,
      labels: {
        style: {
          fontSize: '14px',
          fontWeight: '600',
          color: '#2c3e50'
        }
      }
    },
    yAxis: [{
      min: 0,
      title: {
        text: ''
      },
      labels: {
        enabled: false
      },
      gridLineWidth: 0,
    }],
    legend: {
      enabled: false
    },
    tooltip: {
      backgroundColor: '#ffffff',
      borderWidth: 0,
      borderRadius: 8,
      shadow: true,
      style: {
        fontSize: '14px'
      },
      formatter: function() {
        return '<b>' + this.x + '</b><br/>' +
          'Goal: ' + this.point.total + 'g<br/>' +
          'Actual: ' + this.y + 'g';
      }
    },
    plotOptions: {
      column: {
        grouping: false,
        shadow: false,
        borderWidth: 0,
        borderRadius: 8
      }
    },
    series: [{
      name: 'Goal',
      data: [[0, 12], [1, 8], [2, 43]],
      color: 'rgba(44, 62, 80, 0.15)',
      enableMouseTracking: true,
      pointPadding: 0.4,
      pointPlacement: -0.1,
      type: 'column'
    },
    {
      name: 'Actual',
      data: [[0, 6], [1, 4], [2, 30]],
      color: '#2196f3',
      enableMouseTracking: true,
      pointPadding: 0.4,
      pointPlacement: -0.1,
      type: 'column'
    }] as any
  }
  unsubscriber:Subject<void> =new Subject<void>();

  ngOnInit(): void {
    this.companyUrl = this.authService.getCompanyUrl();
    this.route.queryParams.subscribe((params: any) => {
      if (params.tab) {
        this.isConsultantView = true;
      }
      else {
        const id = this.route.snapshot.paramMap.get('id');
        if (id) this.isConsultantView = true;
      }
    })

    if (!this.selectedUserRole) {
      const routes:any = [
        { name: 'Dashboard', path: 'clientdashboard'}
      ];
      this.commonService.setHeaderData(routes);
    }
    const userRole = parseInt(this.authService.getUserRole());
      if (AppConstants.Constants.CLIENT_ROLE === userRole || this.selectedUserRole === AppConstants.Constants.CLIENT_ROLE) {
        this.isDisplayClientDashboard = true;
      } else {
        this.isDisplayClientDashboard = false;
      }
    if (this.isDisplayClientDashboard) {
      this.getClientDashboard();
    }
    
    // Subscribe to company details and get current client count only when NOT displaying client dashboard
    this.authService.onCompanyDetails.subscribe(details => {
      this.companyDetails = details;
      if (details && details.id && !this.isDisplayClientDashboard) {
        this.getCurrentClientCount();
      }
    });

    // Subscribe to client data changes to automatically update count only when NOT displaying client dashboard
    this.clientDataService.clientData$.pipe(takeUntil(this.unsubscriber)).subscribe(data => {
      if (data && this.companyDetails && data.companyId === this.companyDetails.id && !this.isDisplayClientDashboard) {
        this.currentClientCount = data.totalCount;
      }
    });
    
    // If company details are not loaded, fetch them
    if (!this.companyDetails || !this.companyDetails.id) {
      this.authService.getCustomerData();
    }
  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  getClientDashboard() {
    this.loader.showSpinner();
    const url = `${config.apiUrl}/clientdashboard`;
    const reqData:any = {
      "logdate": this.commonService.getGeneralFormatDate(this.goalsDate.value)
    };
    const userIdVal = parseInt(this.userId);
    if (userIdVal > 0) {
      reqData['user_id'] = userIdVal;
    }

    this.httpService.postCall(url, reqData).subscribe(result => {
      this.isDashboardLoaded = true;
      const weeksNow = this.commonService.weeksBetween(new Date(result.goal.start_date));
      this.dashboardData = result;
      if (this.dashboardData.weights && this.dashboardData.weights.length === 0) {
        this.dashboardData.weights = [{ leanmuscle: 0, bodyfat: 0, weight: 0 }];
      }
      this.dashboardData.weeksNow = weeksNow;
      this.dashboardData.weightsDiffer = this.commonService.differValues(result.weights[result.weights.length - 1].weight, result.weights[0].weight);
      this.dashboardData.bodyfatDiffer = this.commonService.differValues(result.weights[result.weights.length - 1].bodyfat, result.weights[0].bodyfat);
      this.dashboardData.musclemassDiffer = this.commonService.differValues(result.weights[result.weights.length - 1].leanmuscle, result.weights[0].leanmuscle);
      this.calculateExercises(result);
      const xaxisData:any = this.nutritionChartOptions.xAxis;
      xaxisData.categories = [
        `Protein <br/> <span>${this.commonService.roundValues(result.nutrition.protein.consumed)} / ${this.commonService.roundValues(result.nutrition.protein.total)}g</span`,
        `Fat<br/> <span>${this.commonService.roundValues(result.nutrition.fat.consumed) } / ${ this.commonService.roundValues(result.nutrition.fat.total)}g</span`,
        `Carbs<br/> <span>${this.commonService.roundValues(result.nutrition.carbs.consumed) } / ${ this.commonService.roundValues(result.nutrition.carbs.total)}g</span`
    ];
      const seriesData:any = this.nutritionChartOptions.series; 
      seriesData[0].data = [
        result.nutrition.protein.total,
        result.nutrition.fat.total,
        result.nutrition.carbs.total
      ];
      seriesData[1].data = [
        result.nutrition.protein.consumed,
        result.nutrition.fat.consumed,
        result.nutrition.carbs.consumed
      ];
      this.updateNutritionFlag = true;
      this.calculateTopChartsSection(result);
      this.errorMsg = '';
      this.loader.stopSpinner();
    }, err => {
      this.loader.stopSpinner();
      this.errorMsg = err?.error?.message || '';
      if (!this.errorMsg) {
        this.errorMsg = err?.error?.error || '';
      }
      if (err.status !== 404 && err.status !== 500) {
        this.toasterService.show('error', 'Error Occurred', this.errorMsg);
      }
    });
  }

  formatDateToYYYYMMDD(date:any) {
    if (!(date instanceof Date)) {
        throw new Error('Invalid input; expected a Date object.');
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    // Return formatted date string in "YYYYMMDD" format
    return `${year}${month}${day}`;
}

  navugateToClientPage(page:any){
    const url = `${config.apiUrl}/companyadmin/impersonate/${this.userId}`;
    this.httpService.getCall(url).subscribe((res)=>{
      this.authService.storeCompanyIdValuesAsMap(res.userData.id, res.companyAdminId);
      let sortDate = this.formatDateToYYYYMMDD(this.goalsDate.value).replace(/\-/gi,"");
      this.authService.onActAsUser(res, true, page == "exercise"  ? "CLIENT_ACTIVE_EXERCISE_PLAN" : "CLIENT_ACTIVE_NUTRITION_PLAN",sortDate);
    }, (err) => {
      console.log(err);
    });
  }

  calculateTopChartsSection(result: any) {
    const weights:any = [];
    const bodyfat:any = [];
    const leanmuscle:any = [];
    result.weights.forEach((item:any) => {
      weights.unshift(item.weight);
      bodyfat.unshift(item.bodyfat);
      leanmuscle.unshift(item.leanmuscle);
    });

    const dashboardWeight:any = this.dashboardWeightChartOptions.series; 
    dashboardWeight[0].data = weights;

    const dashboardBodyFat:any = this.dashboardBodyFatChartOptions.series; 
    dashboardBodyFat[0].data = bodyfat;

    const dashboardLeanMuscle:any = this.dashboardLeanMuscleChartOptions.series; 
    dashboardLeanMuscle[0].data = leanmuscle;
  }

  calculateExercises(result:any) {
    const order = ["exercises", "sets", "reps", "cardio"];
    order.forEach((key, index) => {
      this.exerciseData[index].total = result.exercise[key].total;
      this.exerciseData[index].actual = result.exercise[key].consumed;
      this.exerciseData[index].percent = this.commonService.getPercentageValue(result.exercise[key].consumed, result.exercise[key].total);
    });

  }

  highcharts = Highcharts;

  dashboardWeightChartOptions: Highcharts.Options = {
    title: {
      text: "",
    },
    credits: {
      enabled: false
    },
    xAxis: {
        gridLineWidth: 0,
        lineWidth: 0,
        labels: {
          enabled: false
        },
        visible: false
    },
    yAxis: {
      title: {
        text: ""
      },
      labels: {
        enabled: false
      },
      gridLineWidth: 0,
    },
    plotOptions: {
      series: {
          marker: {
              enabled: false
          }
      }
  },
  legend: {
    enabled: false
  },
  tooltip: {
    enabled: false
  },
    series: [{
      data: [12, 8, 43, 35, 20, 90, 100, 110],
      type: 'spline',
      color: '#4299e1',
      enableMouseTracking: false,
      lineWidth: 3,
      shadow: {
        color: 'rgba(66, 153, 225, 0.2)',
        width: 8,
        offsetY: 4
      }
    }]
  }

  dashboardBodyFatChartOptions: Highcharts.Options = {
    title: {
      text: "",
    },
    credits: {
      enabled: false
    },
    xAxis: {
        gridLineWidth: 0,
        lineWidth: 0,
        labels: {
          enabled: false
        },
        visible: false
    },
    yAxis: {
      title: {
        text: ""
      },
      labels: {
        enabled: false
      },
      gridLineWidth: 0,
    },
    plotOptions: {
      series: {
          marker: {
              enabled: false
          }
      }
  },
  legend: {
    enabled: false
  },
  tooltip: {
    enabled: false
  },
    series: [{
      data: [12, 8, 43, 35, 20, 90, 100, 110],
      type: 'spline',
      color: '#4299e1',
      enableMouseTracking: false,
      lineWidth: 3,
      shadow: {
        color: 'rgba(66, 153, 225, 0.2)',
        width: 8,
        offsetY: 4
      }
    }]
  }

  dashboardLeanMuscleChartOptions: Highcharts.Options = {
    title: {
      text: "",
    },
    credits: {
      enabled: false
    },
    xAxis: {
        gridLineWidth: 0,
        lineWidth: 0,
        labels: {
          enabled: false
        },
        visible: false
    },
    yAxis: {
      title: {
        text: ""
      },
      labels: {
        enabled: false
      },
      gridLineWidth: 0,
    },
    plotOptions: {
      series: {
          marker: {
              enabled: false
          }
      }
  },
  legend: {
    enabled: false
  },
  tooltip: {
    enabled: false
  },
    series: [{
      data: [12, 8, 43, 35, 20, 90, 100, 110],
      type: 'spline',
      color: '#4299e1',
      enableMouseTracking: false,
      lineWidth: 3,
      shadow: {
        color: 'rgba(66, 153, 225, 0.2)',
        width: 8,
        offsetY: 4
      }
    }]
  }
    onDateSelect(event:any) {
      const datepickerDate = this.commonService.getGeneralFormatDate(this.goalsDate.value);
      const todayDate = this.commonService.getGeneralFormatDate(new Date());
      if (datepickerDate === todayDate) {
        this.isTodayDate = true;
      } else {
        this.isTodayDate = false;
      }
      this.getClientDashboard();
    }

    getCurrentClientCount() {
      if (this.isDisplayClientDashboard || !this.companyDetails || !this.companyDetails.id) return;
      
      // First try to get cached data
      const cachedCount = this.clientDataService.getCurrentClientCount(this.companyDetails.id);
      if (cachedCount > 0 || this.clientDataService.hasFreshData(this.companyDetails.id)) {
        this.currentClientCount = cachedCount;
        return;
      }
      
      // If no cached data, fetch from API
      this.clientDataService.getClientCount(this.companyDetails.id).subscribe(
        count => {
          this.currentClientCount = count;
        },
        err => {
          console.error('Error fetching client count:', err);
        }
      );
    }

    navigateToBilling() {
      this.router.navigate(['/billing']);
    }

    isTrialLimitReached(): boolean {
      if (this.isDisplayClientDashboard) return false;
      return this.companyDetails && 
             this.companyDetails.is_trial && 
             this.currentClientCount >= this.companyDetails.trial_client_limit;
    }

    isTrialExpired(): boolean {
      if (this.isDisplayClientDashboard) return false;
      return this.clientDataService.isTrialExpired(this.companyDetails);
    }

    isTrialActive(): boolean {
      if (this.isDisplayClientDashboard) return false;
      return this.clientDataService.isTrialActive(this.companyDetails);
    }

    getRemainingTrialDays(): number {
      if (this.isDisplayClientDashboard) return 0;
      return this.clientDataService.getRemainingTrialDays(this.companyDetails);
    }

    shouldShowTrialWarning(): boolean {
      if (this.isDisplayClientDashboard || !this.companyDetails || !this.companyDetails.is_trial) return false;
      
      // Show warning if trial is expired OR client limit is reached
      return this.isTrialExpired() || this.isTrialLimitReached();
    }

    getTrialStatusMessage(): string {
      if (this.isDisplayClientDashboard || !this.companyDetails || !this.companyDetails.is_trial) return '';
      
      if (this.isTrialExpired()) {
        return 'Trial Period Expired';
      } else if (this.isTrialLimitReached()) {
        return 'Trial Limit Reached';
      } else {
        const remainingDays = this.getRemainingTrialDays();
        if (remainingDays <= 3) {
          return `Trial Expires Soon (${remainingDays} days left)`;
        }
        return 'Trial Account Active';
      }
    }

    getTrialSubtitleMessage(): string {
      if (this.isDisplayClientDashboard || !this.companyDetails || !this.companyDetails.is_trial) return '';
      
      if (this.isTrialExpired()) {
        return 'Your trial period has ended. Upgrade to continue using all features.';
      } else if (this.isTrialLimitReached()) {
        return `You've used all ${this.companyDetails.trial_client_limit} client slots. Upgrade to add more clients and unlock premium features.`;
      } else {
        const remainingDays = this.getRemainingTrialDays();
        return `You're currently using ${this.currentClientCount} of ${this.companyDetails.trial_client_limit} available client slots. ${remainingDays} days remaining in trial.`;
      }
    }

    getTrialStatusText(): string {
      if (this.isDisplayClientDashboard || !this.companyDetails || !this.companyDetails.is_trial) return '';
      
      const used = this.currentClientCount;
      const limit = this.companyDetails.trial_client_limit;
      
      if (used >= limit) {
        return `Trial limit reached (${used}/${limit} clients used)`;
      } else {
        return `Trial account (${used}/${limit} clients used)`;
      }
    }

    getTrialStatsNumber(): number {
      if (this.isDisplayClientDashboard || !this.companyDetails || !this.companyDetails.is_trial) return 0;
      
      const remaining = this.companyDetails.trial_client_limit - this.currentClientCount;
      return Math.max(0, remaining);
    }

    getTrialStatsLabel(): string {
      if (this.isDisplayClientDashboard || !this.companyDetails || !this.companyDetails.is_trial) return '';
      
      const remaining = this.companyDetails.trial_client_limit - this.currentClientCount;
      if (remaining <= 0) {
        return 'Limit Reached';
      } else {
        return remaining === 1 ? 'Slot Left' : 'Slots Left';
      }
    }

  }